<template>
  <div :class="wrapperClass">
    <div :class="controlsClass">
      <div
        v-if="labelPosition === 'start'"
        class="toggle__label toggle__label--start"
        @click="value = !value">
        {{ value ? translate(onLabel) : translate(offLabel) }}
      </div>
      <div
        v-if="labelPosition === 'both'"
        class="toggle__label toggle__label--start"
        @click="value = false">
        {{ translate(offLabel) }}
      </div>
      <div class="toggle__controls-line"
           @click="value = !value">
        <div class="toggle__controls-knob flex-middle flex-center"
        :class="{'bg-success': !!value, 'bg-error': !value}">
          <icon
            v-show="!value"
            icon="x"
            theme="bg"
            class="animate__fadeIn animate--faster" />
          <icon
            v-show="value"
            icon="check"
            theme="bg"
            class="animate__fadeIn animate--faster" />
        </div>
      </div>
      <div
        v-if="labelPosition === 'end'"
        class="toggle__label toggle__label--end"
        @click="value = !value">
        {{ value ? translate(onLabel) : translate(offLabel) }}
      </div>
      <div
        v-if="labelPosition === 'both'"
        class="toggle__label toggle__label--end"
        @click="value = true">
        {{ translate(onLabel) }}
      </div>
    </div>
    <input v-model="value" type="hidden" v-bind="inputAttrs"  ref="actualInput"/>
  </div>
</template>

<script>
import ToggleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/toggleInput.js";

export default {
  mixins: [ToggleInputMixin],
  props: {
    modelValue: {}, // this doesn't work from mixin. reason - unknown
  },
  data: function () {
    return {};
  },

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", !!val);

      },
    }
  },
  watch: {
    modelValue: {
      // disallow non-boolean values
      handler: function (newValue,oldValue)
      {
        return true;
      },
      immediate: true,
    },
  },
};
</script>
